import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import SingleMonthLayer from 'components/calendar/SingleMonthLayer'
import {
  CalendarContext,
  DatePickerContext,
} from 'components/calendar/CalendarContext'
import classNames from 'classnames'
import moment from 'moment'
import Moment from 'react-moment'
import { getVisibleMonth } from 'components/calendar/calendarUtil'
import NoneAnchor from '../NoneAnchor'
import useOutsideClick from '../../utils/hooks/useOutsideClick'

const DatePicker = ({
  value: valueString,
  min: minString,
  max: maxString,
  onChange,
  disabled = false,
  error,
}) => {
  const [active, setActive] = useState(false)
  const [value, setValue] = useState(valueString ? moment(valueString) : null)
  const [month, setMonth] = useState(getVisibleMonth(valueString))
  useEffect(() => {
    setValue(valueString ? moment(valueString) : null)
    setMonth(getVisibleMonth(valueString))
  }, [valueString])
  const [min, setMin] = useState(minString ? moment(minString) : null)
  useEffect(() => {
    setMin(minString ? moment(minString) : null)
  }, [minString])
  const [max, setMax] = useState(maxString ? moment(maxString) : null)
  useEffect(() => {
    setMax(maxString ? moment(maxString) : null)
  }, [maxString])
  const reset = () => {
    setValue(valueString ? moment(valueString) : null)
    setMonth(getVisibleMonth(valueString))
  }
  const close = () => {
    setActive(false)
  }
  const toggle = () => {
    if (disabled === false) {
      setActive(state => !state)
    }
  }
  const handleCancel = () => {
    close()
    reset()
  }
  const ref = useOutsideClick(handleCancel)
  return (
    <CalendarContext.Provider
      value={{
        min,
        max,
        close,
        reset,
        onChange,
      }}>
      <DatePickerContext.Provider
        value={{
          value,
          setValue,
          month,
          setMonth,
        }}>
        <div
          ref={ref}
          className={classNames('btn_gm gm_calendar single_calendar', {
            open: active,
          })}>
          <NoneAnchor
            className={classNames('link_calendar', {
              on: active,
              in_active: disabled,
              in_error: error,
            })}
            onClick={toggle}>
            {valueString && <Moment format="YYYY.MM.DD">{valueString}</Moment>}
            <span className="ico_comm ico_calendar" />
          </NoneAnchor>
          {active && <SingleMonthLayer />}
        </div>
      </DatePickerContext.Provider>
    </CalendarContext.Provider>
  )
}

DatePicker.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  max: PropTypes.string,
  min: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.any,
}

export default DatePicker
